import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { CategorizationService } from 'src/app/services/categorization.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ProjectService } from 'src/app/services/project.service';

@Component({
  selector: 'app-multi-select-editor',
  templateUrl: './multi-select-editor.component.html',
  styleUrls: ['./multi-select-editor.component.css']
})
export class MultiSelectEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  private params: any;
  public selectedValues: any[] = [];
  public options: any[] = [];
  projectId: any;
  public businessAreaId: number;
  public businessLineId: number;
  Standdata: any;
  cellWidth: number = 80;
  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    private catService: CategorizationService,
    // private projectService: ProjectService,
    // private localStorageService: LocalStorageService,
    public dialog: MatDialog,
  ) { }

  agInit(params: any): void {
    this.params = params;
    this.cellWidth = params?.column?.actualWidth || 80; // get cell width from params
    this.catService.getTCstand(params.data.businessAreaId, params.data.businessLineId).subscribe((measureStatus: any) => {
      let errorMsgeFromBack = measureStatus.Data.Message;
      if (measureStatus.StatusCode == 200) {
        this.Standdata = measureStatus.Data;
        this.Standdata.forEach(element => {
          let option = {
            "ID": element.ID,
            "StandTitle": element.StandTitle,
          }
          this.options.push(option);

        });
        this.selectedValues = params.data.Stands;
        setTimeout(() => {
          this.matSelect?.open();
        }, 0);
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
      }
    }, (error) => {
      //Show errorCode and errorMessage in the UI
      this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
    });
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  getValue(): any {
    return this.selectedValues;
  }

  onOpenedChange(opened: boolean) {
    // console.log("hello");
    if (!opened) {
      this.params.api.stopEditing();
    }
  }

  isPopup(): boolean {
    return true;
  }
  compareItems(item1: any, item2: any): boolean {
    return item1 && item2 && item1.ID == item2.ID;
  }

  ngAfterViewInit() {
    // Open the dropdown after the view is initialized
    setTimeout(() => {
      this.matSelect?.open();
    }, 0);
  }
}
